<template>
  <main>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-80 md-small-size-100">
        <md-card>
          <md-card-header>
            <div class="md-title">特定商取引法に基づく表記</div>
          </md-card-header>

          <md-card-content>
            <md-table md-card>
              <md-table-row>
                <md-table-cell class="title">販売業社名</md-table-cell>
                <md-table-cell>
                  <p>株式会社JON</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">代表者</md-table-cell>
                <md-table-cell>
                  <p>中川　元</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">所在地</md-table-cell>
                <md-table-cell>
                  <p>東京都新宿区新小川町5-1　ニューリバー51　4F</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">連絡先</md-table-cell>
                <md-table-cell>
                  <p>03-3269-1220　(土日祝祭日年末年始を除く10:00～17:00)</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">URL</md-table-cell>
                <md-table-cell>
                  <a href="https://shikakumap.jp/" rel="noopener" target="_blank">https://shikakumap.jp/</a>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">支払方法</md-table-cell>
                <md-table-cell>
                  <ul>
                    <li>
                      クレジットカード(VISA/Master/AMEX/JCB/DINERS)<br/>
                      <img src="https://cdn.jon-api.com/shikaku-map/img/cards.png" width="33%"></p>
                      <span class="md-caption">※クレジットのご利用枠/利用条件、料金引き落とし日などにつきましては、カード発行会社により異なります。ご契約内容を事前にご確認ください。</span>
                    </li>
                  </ul>
                  <ul>
                    <li>銀行振込</li>
                  </ul>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">支払期限</md-table-cell>
                <md-table-cell>
                  <p>月末締め翌月払い</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">商品引渡し時期</md-table-cell>
                <md-table-cell>
                  <p>ご登録手続き完了次第、ご利用いただけます。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">販売価格</md-table-cell>
                <md-table-cell>
                  <p>ご契約内容に応じて、料金シミュレーションにて提示致します。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">商品代金以外の必要料金</md-table-cell>
                <md-table-cell>
                  <ul>
                    <li>消費税、銀行振込手数料をご負担いただきます。</li>
                    <li>請求書郵送をご希望の場合は¥300/月をご負担いただきます。</li>
                  </ul>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">販売条件</md-table-cell>
                <md-table-cell>
                  <p>1か月単位の自動更新契約となります。ご利用には、利用規約への同意が必要です。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">返品交換について</md-table-cell>
                <md-table-cell>
                  <p>デジタルコンテンツという商品の性質上、返品はできかねます。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">解約について</md-table-cell>
                <md-table-cell>
                  <p>ログイン後のメニュー「退会」ボタンから可能です。毎月末日正午までに申し出をすることにより、当月末日をもって解約となります。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">動作環境</md-table-cell>
                <md-table-cell>
                  <p>動作環境につきましては、以下を推奨します。</p>
                  <ul>
                    <li>Windows11以降、Microsoft Edge最新</li>
                    <li>Windows11以降、Google Chrome最新</li>
                    <li>macOS最新、Google Chrome最新</li>
                  </ul>
                  <p>動作確認済み環境</p>
                  <ul>
                    <li>iPadOS最新、Safari最新</li>
                  </ul>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-10"></div>
    </div>
  </main>
</template>

<script>
import CommonMixin from "@/mixins/commonMixin";

export default {
    name   : "Legal",
    mixins: [CommonMixin],
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/components.scss";

  .md-table:nth-child(1) {
    .md-table-row {
      .md-table-cell.title {
        background: #eee;
      }

      .md-table-cell:nth-child(1) {
        width: 25%;
      }

      &:hover:not(.md-header-row) .md-table-cell:not(.title) {
        background: unset !important;
      }
    }
  }

</style>
